import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Config from '../../../../Config';
import { goToPage, setPercent, report } from '../MovingBlockSlice';
import Complete from '../Partials/Complete/Complete';
import GenericDetails from '../Partials/GenericDetails/GenericDetails';
import MovingFooter from '../Partials/MovingFooter/MovingFooter';
import ProgressLine from '../Partials/ProgressLine/ProgressLine';
import EpiContext from '@episerver/spa-core/Spa';
import Helper from '../../../../utilities/helper';
import { gtag4 } from '../../../../utilities/analytics/tracking';

const CompletePage = (props) => {

  const btnText = 'סיום';

  useEffect(() => {
    props.setPercent(100);
    if (props.movingWithTechnician) {
      if (props.pinTechnicianDetails?.isTechnician) {
        gtag4({
          event: 'Moving_Step5_SuccessTechPinPage_4',
          title: 'מעולה! ההזמנה למעבר דירה בוצעה בהצלחה',
          step: '5',
          action: 'SuccessTechPinPage_4',
          funnel_name: '1 - MovingWithProducts',
        });
      }
      else {
        gtag4({
          event: 'Moving_Step5_SuccessPage_S4',
          title: 'מעולה! ההזמנה למעבר דירה בוצעה בהצלחה',
          step: '5',
          action: 'SuccessPage_S4',
          funnel_name: '1 - MovingWithProducts',
        });
      }
      props.report({ actionType: "Create Moving Order", status: "Completed", messageText: "Success", products: props.products, param2: props.fullAddress, selectedProducts: props.selectedProducts, param4: props.selectedEntry?.infrastructure, param5: props.fullDate, param6: props.isCollaborationApproval, param7: props.email.value, param8: props.contactDetails.phone, param9: props.technicianType, param10: props.workOrderDetails?.code })
    }
    else {
      gtag4({
        event: 'Moving_Step3_UpdateAddressSuccessPage',
        title: 'עדכון הכתובת בוצע בהצלחה!',
        step: '3',
        action: 'UpdateAddressSuccessPage',
        funnel_name: '2 - MovingWithoutProducts',
      });
      props.report({ actionType: 'Address Update', status: 'Completed', messageText: 'Success', products: props.products, param2: props.fullAddress, param4: props.selectedEntry?.infrastructure, param6: props.isCollaborationApproval, param7: props.email.value })
    }
  }, []);

  function handleBtnClick() {
    EpiContext.navigateTo(Config.lobbyUrl)
  }

  return (
    <>
      <ProgressLine percent={props.percent} />
      <Complete fullAddress={props.fullAddress} userDetails={props.userDetails} isPinTechnician={props.pinTechnicianDetails?.isTechnician} />
      <GenericDetails fullAddress={props.fullAddress} />

      {props.movingWithTechnician &&
        <div className='save-and-schedule-container'>
          <div className='save-and-schedule'>
            <div onClick={() => Helper.saveToImage('.moving-apartment-block')}>שמירה כתמונה</div>
            <div onClick={() => Helper.saveToCalendar()}>הוספת תזכורת ליומן</div>
          </div>
        </div>
      }
      <MovingFooter onBtnClick={handleBtnClick} btnText={btnText} />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    page: state.movingBlock.page,
    percent: state.movingBlock.movingApartmentData.percent,
    userDetails: state.authentication.loginData.userDetails,
    fullAddress: state.movingBlock.movingApartmentData.address?.fullAddress,
    movingWithTechnician: state.movingBlock.movingApartmentData.movingWithTechnician,
    email: state.movingBlock.movingApartmentData.email,
    products: state.movingBlock.movingApartmentData.products,
    isCollaborationApproval: state.movingBlock.movingApartmentData.isCollaborationApproval,
    fullDate: state.movingBlock.movingApartmentData.technicianData.selectedTechnicianTimeSlot.fullDate,
    selectedProducts: state.movingBlock.movingApartmentData.selectedProducts,
    selectedEntry: state.movingBlock.movingApartmentData.address.selectedEntry,
    contactDetails: state.movingBlock.movingApartmentData.contactDetails,
    pinTechnicianDetails: state.movingBlock.movingApartmentData.pinTechnicianDetails,
    technicianType: state.movingBlock.movingApartmentData.technicianType,
    workOrderDetails: state.movingBlock.movingApartmentData.workOrderDetails
  };
};

const mapDispatchToProps = { goToPage, setPercent, report };

export default connect(mapStateToProps, mapDispatchToProps)(CompletePage);
